import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
var MobileSegmentFlatTime = function (props) {
    var _a;
    var theme = useTheme('MobileSegmentInfo').MobileSegmentFlat;
    return (React.createElement("div", { className: cn(theme.row, theme.row_time, props.className, (_a = {},
            _a[theme.row_first] = props.segmentType === 'first',
            _a[theme.row_last] = props.segmentType === 'last',
            _a)) },
        React.createElement("div", { className: cn(theme.time, theme.time_dep, props.timeClassName) },
            React.createElement("div", { className: theme.date }, props.departureDate),
            React.createElement("div", { className: theme.time__value }, props.departureTime),
            React.createElement("div", { className: cn(theme.city) }, props.departureCity)),
        React.createElement("div", { className: theme.duration__wrapper },
            React.createElement("div", { className: theme.duration },
                React.createElement("div", { className: theme.duration__point }),
                React.createElement("span", null,
                    React.createElement("span", { className: theme.duration__text }, props.durationTime),
                    props.flightNumber && React.createElement("div", { className: theme.flightNumber__route }, props.flightNumber)))),
        React.createElement("div", { className: cn(theme.time, theme.time_arr, props.timeClassName) },
            React.createElement("div", { className: theme.date }, props.arrivalDate),
            React.createElement("div", { className: theme.time__value }, props.arrivalTime),
            React.createElement("div", { className: cn(theme.city) }, props.arrivalCity))));
};
export default MobileSegmentFlatTime;
